import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    distributor: {
        name: null,
        code: null,
        address: null,
        postal_code: null,
        city: null,
        country: 'Malaysia',
        outlet_id: null,
        region: null,
        outlet: null,
        status: 1,
        account_name: null,
        account_number: null,
        shipping_terms: null,
        contacts: [
            {
                contact_name: null,
                contact_email: null,
                contact_no: null,
                contact_fax: null,
            },
        ],
        suppliers: [],
    },
    distributorOutletList: [],
    outlet: {
        distributors: [],
        distributorIds: [],
    },
    distributorSuppliers: [],
    distributorList: [],
};

const getters = {
    distributor: state => state.distributor,

    distributorOutletList: state => state.distributorOutletList,

    outlet: state => state.outlet,

    distributorSuppliers: state => state.distributorSuppliers,

    distributorList: state => state.distributorList,
};

const mutations = {
    setDistributor(state, data) {
        if (!data.contacts.length) {
            data.contacts.push({
                contact_name: null,
                contact_email: null,
                contact_no: null,
                contact_fax: null,
            });
        }

        state.distributor = data;
    },

    setDistributorAttr(state, { key, value }) {
        state.distributor[key] = value;
    },

    setClearDistributor(state) {
        state.distributor = {
            name: null,
            code: null,
            address: null,
            postal_code: null,
            city: null,
            country: 'Malaysia',
            outlet_id: null,
            region: null,
            outlet: null,
            status: 1,
            account_name: null,
            account_number: null,
            shipping_terms: null,
            contacts: [
                {
                    contact_name: null,
                    contact_email: null,
                    contact_no: null,
                    contact_fax: null,
                },
            ],
        };
    },

    setDistributorOutletList(state, data) {
        state.distributorOutletList = data;
    },

    setOutlet(state, data) {
        state.outlet = data;
    },

    setDistributorSuppliers(state, data) {
        state.distributorSuppliers = data;
    },

    setDistributorList(state, data) {
        state.distributorList = data;
    },
};

const actions = {
    async getDistributor({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.distributor.show', { id });
        startLoading(dispatch, 'fetch-distributor');

        try {
            const { data } = await axios.get(url);
            commit('setDistributor', data);
            commit('setDistributorSuppliers', data.suppliers);

            endLoading(dispatch, 'fetch-distributor');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-distributor');
            throw e;
        }
    },

    async createDistributor({ dispatch, state }) {
        startLoading(dispatch, 'save-distributor');
        const url = Laroute.route('inventory.distributor.create');

        try {
            const { data } = await axios.post(url, state.distributor);
            endLoading(dispatch, 'save-distributor');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-distributor');
            throw e;
        }
    },

    async updateDistributor({ commit, dispatch, state }) {
        startLoading(dispatch, 'save-distributor');

        const url = Laroute.route('inventory.distributor.update');

        try {
            const { data } = await axios.put(url, state.distributor);
            commit('setDistributor', data);
            endLoading(dispatch, 'save-distributor');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-distributor');
            throw e;
        }
    },

    clearDistributor({ commit }) {
        commit('setClearDistributor');
    },

    async getDistributorOutletList({ commit, dispatch }, id) {
        const url = Laroute.route('inventory.distributor.outlet.list', { id });
        startLoading(dispatch, 'fetch-distributor-outlet-list');

        try {
            const { data } = await axios.get(url);
            commit('setDistributorOutletList', data);
            endLoading(dispatch, 'fetch-distributor-outlet-list');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-distributor-outlet-list');
            throw e;
        }
    },

    async updateDistributorSupplier({ dispatch, state, commit }) {
        const url = Laroute.route('inventory.distributor.update.suppliers');
        startLoading(dispatch, 'save-distributor-supplier');

        try {
            const { data } = await axios.put(url, state.distributor);
            commit('setDistributorSuppliers', state.distributor.suppliers);

            endLoading(dispatch, 'save-distributor-supplier');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-distributor-supplier');
            throw e;
        }
    },

    async updateDistributorOutlet({ dispatch, state }) {
        state.outlet.distributorIds = state.outlet.distributors.map(d => d.id);

        delete state.outlet.distributors;

        const url = Laroute.route('inventory.distributor.update.outlet');
        startLoading(dispatch, 'save-distributor-outlet');

        try {
            const { data } = await axios.put(url, state.outlet);
            endLoading(dispatch, 'save-distributor-outlet');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-distributor-outlet');
            throw e;
        }
    },

    async getOutletDistributors(
        { dispatch, commit, state },
        { outletId, params = {} },
    ) {
        const url = Laroute.route('inventory.distributor.outlet.distributors', {
            outletId,
        });

        startLoading(dispatch, 'get-outlet-distributor');

        const options = {
            params: Object.assign(params),
        };

        try {
            const { data } = await axios.get(url, options);
            commit('setOutlet', data);
            endLoading(dispatch, 'get-outlet-distributor');

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-outlet-distributor');
            throw e;
        }
    },

    async getDistributorList({ commit, dispatch }, params = {}) {
        const url = Laroute.route('inventory.distributor.list');
        startLoading(dispatch, 'fetch-distributors');

        const options = Object.assign(
            {
                query: '',
                limit: 15,
            },
            params,
        );

        try {
            const { data } = await axios.post(url, options);
            commit('setDistributorList', data.data);
            endLoading(dispatch, 'fetch-distributors');

            return data.data;
        } catch (e) {
            endLoading(dispatch, 'fetch-distributors');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
